import { BookOpenTextIcon, CalendarCheckIcon, CalendarXIcon, ClipboardCheckIcon, DicesIcon, FileTextIcon, FolderSearchIcon, LayoutGridIcon, LightbulbIcon, PencilRulerIcon, ShapesIcon, ShuffleIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
// Caja 3D transparente de los 6 volume (placeholder: subir la caja de JUDO GATA a Recursos y pegar la URL).
export const PRODUCT_IMAGE = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/e05aaa13-2e1b-433d-adf2-9e0d12018597/1793774606055_judogata-caja-6-volume-transparenta-2e57d990.webp';
export const heroGuarantees = ['Descărcare imediată', 'Plată unică', 'Fără abonament', 'Garanție de satisfacție 7 zile'];
export const stats = [{
  value: '240',
  label: 'De pagini în cele șase volume'
}, {
  value: '6',
  label: 'Volume digitale de judo pentru copii'
}, {
  value: '3',
  label: 'Grupe de vârstă – de la 4 la 15 ani'
}, {
  value: '5',
  label: 'Bonusuri incluse'
}, {
  value: '1',
  label: 'Sistem complet pentru tatami'
}];
export const differenceStats = [{
  value: '4–15 ani',
  label: 'De la cei mici la speranțe, în trei grupe de vârstă'
}, {
  value: '6 volume digitale',
  label: 'De la planificarea anuală la examenul de centură'
}, {
  value: 'PDF de printat',
  label: 'Pe tabletă sau printat – direct cu tine pe tatami'
}];
export const beforeItems: Array<{
  title: string;
  text: string;
}> = [{
  title: 'Îți pierzi duminica seara',
  text: 'Ore întregi la laptop pregătind antrenamentele pentru toată săptămâna – și tot nu e gata.'
}, {
  title: 'Ore de căutări',
  text: 'Jocurile de pe internet sunt prea ușoare, prea grele sau nu se potrivesc cu vârsta grupei tale.'
}, {
  title: 'Fiecare antrenament de la zero',
  text: 'Încălzire, ukemi, tehnică, joc, întinderi finale – ce ar trebui să dureze câteva minute devine o muncă în sine.'
}, {
  title: 'Niveluri diferite în aceeași grupă',
  text: 'Centuri albe și centuri verzi pe același tatami: mereu se plictisește cineva.'
}, {
  title: 'Evidența și examenele de centură îți mănâncă timpul',
  text: 'Fișe de progres, programul centurilor, mesaje pentru părinți – încă o muncă după antrenament.'
}, {
  title: 'Stresul dinaintea antrenamentului',
  text: 'Când nu ai timp, improvizezi și inventezi antrenamentul în ultima clipă, lângă tatami.'
}];
export const afterItems = ['Un pachet de judo bine organizat pentru copii de 4–15 ani', 'Antrenamente minut cu minut, ușor de urmat', 'Fișe de antrenament pe care le printezi imediat', '100 de jocuri și exerciții de luptă gata făcute', 'Tehnica pas cu pas și programul centurilor', '3 niveluri pe același tatami', 'Reguli de siguranță clare: fără luxații și fără strangulări', 'Fișe de progres și examene de centură pregătite', 'Plan pentru tot sezonul – din septembrie până în iunie'];
export const recognizeItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: CalendarXIcon,
  title: 'Weekenduri pline de pregătiri',
  text: 'Îți petreci o parte din weekend pregătind antrenamentele de judo pentru săptămâna următoare?'
}, {
  icon: FolderSearchIcon,
  title: 'Nu știi ce joc să alegi',
  text: 'Cauți mereu jocuri și exerciții de luptă potrivite pentru vârsta judoka tăi?'
}, {
  icon: LightbulbIcon,
  title: 'Vrei să explici mai clar',
  text: 'Ai nevoie de ilustrații și de pași ca să le explici copiilor tehnica pe înțelesul lor?'
}, {
  icon: PencilRulerIcon,
  title: 'Vrei să nu mai inventezi totul singur',
  text: 'Ți-ar plăcea ca antrenamentele, jocurile și fișele să fie pregătite dinainte?'
}, {
  icon: ShuffleIcon,
  title: 'Judoka tăi au nevoie de varietate',
  text: 'Vrei mai multe jocuri, forme de luptă și provocări, ca toată grupa să rămână implicată?'
}, {
  icon: LayoutGridIcon,
  title: 'Ai nevoie de o structură clară',
  text: 'Vrei tot materialul la un loc, bine organizat, ca să găsești repede ce îți trebuie?'
}];

// Spine colours mirror the physical box (blue, light blue, green, yellow, orange, red).
export const volumes: Array<{
  number: string;
  level: string;
  title: string;
  tagline: string;
  intro: string;
  items: string[];
  outro: string;
  note?: string;
  spine: string;
  rule: string;
}> = [{
  number: 'Volumul 01',
  level: '4–15 ani',
  title: 'Planificarea anuală și 12 antrenamente',
  tagline: 'Tot sezonul organizat, lună de lună.',
  intro: 'Primul volum conține planificarea anuală pentru trei grupe de vârstă și 12 antrenamente complete, minut cu minut.',
  items: ['Planificarea anuală 4–7, 8–11 și 12–15 ani', 'Săptămâna cu 1, 2 sau 3 antrenamente', 'Structura antrenamentului de 45 și de 60 de minute', '3 niveluri pe același tatami', '12 antrenamente minut cu minut', 'Fișe de antrenament de printat', 'Planul tatamiului și stațiile', 'Siguranță și listă de verificare', 'Fișa de progres a grupei'],
  outro: 'Urci pe tatami și știi exact ce ai de făcut.',
  spine: 'bg-blue-700 text-white',
  rule: 'border-white/30'
}, {
  number: 'Volumul 02',
  level: '4–15 ani',
  title: 'Banca de antrenamente: 50 de antrenamente gata făcute',
  tagline: 'Pentru fiecare situație, un antrenament.',
  intro: 'Al doilea volum conține 50 de antrenamente gata făcute, ordonate pe teme și pe grupe de vârstă.',
  items: ['Structuri de 30, 45 și 60 de minute', '8 antrenamente pentru cei mici', 'Ukemi', 'Lupta la sol și imobilizări', 'Aruncări', 'Jocuri și pregătire fizică', 'Înainte de examenul de centură', 'Înainte de turneu', 'Lecții deschise pentru părinți'],
  outro: 'Alegi, printezi, antrenezi.',
  spine: 'bg-sky-500 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Volumul 03',
  level: '4–15 ani',
  title: '100 de jocuri și exerciții de luptă pentru judo',
  tagline: 'Copiii care se joacă învață și revin.',
  intro: 'Al treilea volum conține 100 de jocuri ordonate după obiectiv și vârstă, cu reguli, variante și siguranță.',
  items: ['20 de jocuri de încălzire', '16 jocuri de ukemi', '16 jocuri de opoziție din picioare', '16 jocuri la sol', '16 jocuri pentru cei mici', '16 jocuri pe echipe', 'Antrenamente 100% prin joc', 'Jocuri pentru spațiu mic', 'Inventează-ți propriul joc'],
  outro: 'Bucuria judoului, fără pregătire.',
  spine: 'bg-green-600 text-white',
  rule: 'border-white/30'
}, {
  number: 'Volumul 04',
  level: '4–15 ani',
  title: 'Tehnica pas cu pas și centurile',
  tagline: 'Fiecare tehnică explicată simplu.',
  intro: 'Al patrulea volum prezintă tehnicile pas cu pas, cu programul centurilor de la albă la maro.',
  items: ['Căderile (ukemi)', '4 imobilizări și ieșirile din ele', '10 aruncări pentru copii', 'Kuzushi și deplasări', 'Programul de la 6 kyu la 1 kyu (de la albă la maro)', 'Fișe de tehnică de printat', 'Greșeli frecvente și corectări', 'Progresie pe niveluri'],
  outro: 'Tehnici sigure, adaptate fiecărei vârste.',
  spine: 'bg-yellow-400 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Volumul 05',
  level: '4–15 ani',
  title: 'Siguranța, grupa și părinții',
  tagline: 'O grupă liniștită, părinți mulțumiți.',
  intro: 'Al cincilea volum te ajută cu siguranța, disciplina în grupă și comunicarea cu părinții.',
  items: ['Reguli de siguranță pe tatami', 'Prim ajutor și accidentări', 'Conducerea grupei și ritualuri', 'Copii dificili sau timizi', 'Comunicarea cu părinții', 'Ședința cu părinții', 'Organizarea sezonului', 'Liste de verificare'],
  outro: 'Mai multă liniște, antrenament după antrenament.',
  spine: 'bg-orange-500 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Volumul 06',
  level: '4–15 ani',
  title: 'Progres, teste și examene de centură',
  tagline: 'Vezi cum crește fiecare judoka.',
  intro: 'Al șaselea volum conține fișe de evaluare, teste fizice și tot ce îți trebuie pentru examenele de centură de la club.',
  items: ['Fișe de progres', 'Teste fizice pe vârste', 'Fișe de evaluare', 'Programul examenelor de centură', 'Fișe de examen de printat', 'Diplome', 'Bilanțul sezonului', 'Evidența grupei'],
  outro: 'Progres vizibil pentru copii și pentru părinți.',
  note: 'Acest material nu este o publicație oficială a Federației Române de Judo (FRJ).',
  spine: 'bg-red-600 text-white',
  rule: 'border-white/30'
}];
export const volumesIntro = {
  title: '6 volume digitale pentru copii de 4–15 ani',
  text: 'Un pachet complet de judo pentru copii, cu care pregătești și ții antrenamentele tot sezonul. Fiecare volum are 40 de pagini cu antrenamente, jocuri, fișe și activități pentru tatami.'
};
export const packItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: BookOpenTextIcon,
  title: 'Antrenamente gata făcute',
  text: 'Gata cu foaia albă. Antrenamente minut cu minut, cu tot cu cuvintele antrenorului – poți începe imediat.'
}, {
  icon: FileTextIcon,
  title: 'Fișe de antrenament de printat',
  text: 'Fișe de antrenament, fișe de progres și fișe de examen de printat și de luat cu tine pe tatami.'
}, {
  icon: ShapesIcon,
  title: 'Ilustrații pe înțeles',
  text: 'Ilustrații, pași și indicații scurte care explică limpede fiecare tehnică și fiecare joc.'
}, {
  icon: DicesIcon,
  title: 'Jocuri și exerciții de luptă',
  text: 'Încălziri, jocuri de ukemi și forme de luptă care implică toată grupa.'
}, {
  icon: ClipboardCheckIcon,
  title: 'Examene de centură fără stres',
  text: 'Programul centurilor, fișe de examen, teste fizice și fișe de progres.'
}, {
  icon: CalendarCheckIcon,
  title: 'Plan pentru tot sezonul',
  text: 'Din septembrie până în iunie: teme, obiective și evenimentele clubului pentru fiecare lună, de la Moș Nicolae la cupa clubului.'
}];
export const pageSamples: Array<{src: string; label: string; title: string; text: string}> = [
  {
    "src": "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/e05aaa13-2e1b-433d-adf2-9e0d12018597/1793764461423_judogata-vol1-p01-2810f4ba.jpg",
    "label": "Volumul 01 · Pagina 1",
    "title": "Coperta",
    "text": "Planificarea anuală și 12 antrenamente minut cu minut."
  },
  {
    "src": "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/e05aaa13-2e1b-433d-adf2-9e0d12018597/1793764470733_judogata-vol1-p04-9fe9072e.jpg",
    "label": "Planificarea anuală · Pagina 4",
    "title": "Planificarea anuală pentru cei mici, 4–7 ani",
    "text": "Tema, obiectivul și evenimentul clubului pentru fiecare lună, din septembrie până în iunie."
  },
  {
    "src": "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/e05aaa13-2e1b-433d-adf2-9e0d12018597/1793764478895_judogata-vol1-p10-94dbaee0.jpg",
    "label": "Antrenamente · Pagina 10",
    "title": "Antrenamentul 1 · Prima zi pe tatami",
    "text": "Minut cu minut: salut, joc de încălzire, ukemi, tehnică și jocuri de opoziție."
  },
  {
    "src": "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/e05aaa13-2e1b-433d-adf2-9e0d12018597/1793764487113_judogata-vol1-p22-9b01a891.jpg",
    "label": "Antrenamente · Pagina 22",
    "title": "Antrenamentul 7 · Prima aruncare: o-goshi",
    "text": "Obiectiv, materiale și sfaturile antrenorului pe o singură pagină."
  },
  {
    "src": "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/e05aaa13-2e1b-433d-adf2-9e0d12018597/1793764494317_judogata-vol1-p35-b80872f3.jpg",
    "label": "Siguranță · Pagina 35",
    "title": "Siguranța pe tatami",
    "text": "10 reguli clare, ca fiecare antrenament să înceapă și să se termine în siguranță."
  }

];
export const pageTypes = ['Antrenamente', 'Fișe de antrenament de printat', 'Jocuri și exerciții de luptă', 'Examene de centură'];
export const bonuses: Array<{
  title: string;
  text: string;
  items: string[];
  benefit: string;
}> = [{
  title: 'Înlocuire fără stres – 12 antrenamente gata pentru antrenorul secund',
  text: 'Grupa se antrenează mai departe, chiar și când tu nu poți veni.',
  items: ['Fișă de predare', '12 antrenamente gata făcute', 'Câte 4 pentru fiecare grupă de vârstă', 'Condică de prezență'],
  benefit: 'Pleci liniștit: antrenamentul are loc.'
}, {
  title: 'Încălziri de judo în 5 minute – 60 de fișe de printat',
  text: '60 de fișe de printat cu care faci o încălzire în cinci minute.',
  items: ['Jocuri de alergare', 'Ukemi și rostogoliri', 'Jocuri în perechi', '5 încălziri gata făcute'],
  benefit: 'La fiecare antrenament, altă încălzire.'
}, {
  title: 'Turneul clubului și ziua porților deschise pas cu pas',
  text: 'Tot ce îți trebuie ca să organizezi un turneu pentru copii și o zi a porților deschise fără haos.',
  items: ['Plan pe 6 săptămâni', 'Tablouri de concurs', 'Diplome de printat', 'Lecție demonstrativă pentru părinți'],
  benefit: 'Un eveniment reușit, fără stres.'
}, {
  title: 'Comunicarea cu părinții – 40 de mesaje gata scrise',
  text: 'Mesaje gata scrise pentru tot sezonul – doar le copiezi și le trimiți.',
  items: ['Înscrierea și începutul sezonului', 'Examene de centură și turnee', 'Antrenament anulat', 'Ședința cu părinții și întrebări frecvente'],
  benefit: 'Părinți informați și mulțumiți.'
}, {
  title: 'Afișe pentru dojo – 15 afișe de printat',
  text: 'Afișe colorate care organizează antrenamentul și transmit valorile judoului.',
  items: ['Regulile tatamiului', 'Cele patru căderi', 'Cele opt valori ale judoului', 'Culorile centurilor'],
  benefit: 'Un dojo care învață copiii chiar și când vorbești tu.'
}];
export const steps: Array<{
  title: string;
  text: string;
}> = [{
  title: 'Deschizi JUDO GATA™',
  text: 'Descarci pachetul și deschizi volumul de care ai nevoie săptămâna aceasta.'
}, {
  title: 'Alegi antrenamentul',
  text: 'Găsești luna și tema și alegi antrenamentul sau jocul potrivit pentru grupa ta.'
}, {
  title: 'Gata în 5 minute',
  text: 'Parcurgi antrenamentul minut cu minut și pregătești materialele.'
}, {
  title: 'Printezi și urci pe tatami',
  text: 'Printezi fișa de antrenament sau o deschizi pe tabletă – și urci pe tatami cu un plan clar.'
}];
export const audienceItems = ['Antrenezi copii la judo, la 4–7, 8–11 sau 12–15 ani', 'Vrei tot sezonul de judo bine organizat', 'Nu vrei să inventezi fiecare antrenament de la zero', 'Ai niveluri diferite pe același tatami', 'Cauți jocuri și exerciții de luptă sigure', 'Vrei fișe de progres și examene de centură pregătite', 'Vrei să câștigi timp în fiecare săptămână', 'Vrei să te simți pregătit la fiecare antrenament'];
export const timeValueTasks = ['Căutarea jocurilor', 'Scrierea antrenamentelor', 'Pregătirea stațiilor și a materialelor', 'Organizarea examenelor de centură', 'Evidența progresului și mesajele pentru părinți'];
export const offerRows: Array<{
  label: string;
  detail: string;
}> = [{
  label: '6 volume digitale – 240 de pagini',
  detail: 'Planificare anuală, antrenamente, jocuri, tehnică, siguranță și examene de centură'
}, {
  label: '5 bonusuri fără cost suplimentar',
  detail: 'Înlocuire, încălziri, turneu, mesaje pentru părinți și afișe'
}, {
  label: 'Pentru copii de 4–15 ani',
  detail: 'Antrenamente gata făcute, fișe de printat și evidența progresului'
}];
export const offerIncludes = ['Descărcare imediată', 'Fișiere PDF pe care le păstrezi', 'Fișe de antrenament de printat', 'Nu se trimite niciun produs fizic'];
export const PRICE = '109 lei';
export const COMPARE_PRICE = '449 lei';

// Only add authentic reviews of JUDO GATA. The section stays hidden while empty.
export const testimonials: Array<{
  quote: string;
  name: string;
  location: string;
}> = [];
export const faqs = [{
  q: 'Cum primesc materialul?',
  a: 'JUDO GATA™ este un produs digital. După cumpărare primești acces la fișierele PDF, pe care le poți descărca și păstra. Le folosești pe calculator, pe tabletă sau pe telefon și printezi fișele de care ai nevoie.'
}, {
  q: 'Se potrivește JUDO GATA™ pentru judoul de copii din România?',
  a: 'Da. Materialul este gândit pentru antrenorii de judo din cluburile și secțiile din România, cu culorile centurilor de la albă la maro (6 kyu – 1 kyu) și cu loc pentru examenele de centură de la clubul tău. Este un material de antrenament independent – acest material nu este o publicație oficială a Federației Române de Judo (FRJ).'
}, {
  q: 'Este potrivit pentru copii de 4–15 ani?',
  a: 'Da. Antrenamentele sunt împărțite pe trei grupe de vârstă (cei mici 4–7 ani, copii 8–11 ani și speranțe 12–15 ani), iar fiecare antrenament are trei niveluri. Alegi după vârsta și experiența grupei tale.'
}, {
  q: 'Este sigur pentru copii?',
  a: 'Da. Căderile sunt mereu pe primul loc, fiecare antrenament are o casetă de siguranță, iar cu copiii nu se lucrează niciodată luxații sau strangulări.'
}, {
  q: 'Chiar pregătesc un antrenament în 5 minute?',
  a: 'JUDO GATA™ este gândit ca să-ți scurteze pregătirea. Deschizi un volum, alegi un antrenament gata făcut și îl parcurgi în aproximativ cinci minute. Timpul poate varia în funcție de grupă și de adaptările pe care le faci.'
}, {
  q: 'Am destul material pentru tot sezonul?',
  a: 'Da. Cele șase volume acoperă tot sezonul, din septembrie până în iunie. Alegi, combini și adaptezi antrenamentele după planul tău și după grupa ta.'
}, {
  q: 'Sunt incluse și fișe de printat?',
  a: 'Da. Pachetul conține fișe de antrenament, fișe de tehnică, fișe de progres, fișe de examen și diplome de printat.'
}, {
  q: 'Pot lucra cu judoka de niveluri diferite?',
  a: 'Da. Fiecare antrenament are trei niveluri, astfel încât începătorii și avansații lucrează pe același tatami, fiecare la nivelul lui.'
}, {
  q: 'Trebuie să printez tot?',
  a: 'Nu. Printezi doar paginile de care ai nevoie; restul le poți vedea pe tabletă sau pe telefon, lângă tatami.'
}, {
  q: 'Toate cele cinci bonusuri sunt incluse în preț?',
  a: `Da. Toate cele cinci bonusuri sunt în pachet fără cost suplimentar – totul împreună pentru ${PRICE}.`
}, {
  q: 'Este un abonament?',
  a: 'Nu. Plătești o singură dată și primești acces la materialul digital. Fără plăți recurente.'
}, {
  q: 'Pot să păstrez fișierele?',
  a: 'Da. Poți descărca și păstra fișierele PDF, în conformitate cu condițiile de utilizare ale produsului.'
}, {
  q: 'Îl pot folosi pe telefon sau pe tabletă?',
  a: 'Da. Deschizi PDF-urile pe calculator, pe tabletă și pe telefon. Pentru a verifica așezarea în pagină înainte de printare, îți recomandăm calculatorul sau tableta.'
}, {
  q: 'Există garanție?',
  a: 'Da. JUDO GATA™ are o garanție de satisfacție de 7 zile. Dacă materialul nu se ridică la așteptările tale, ne trimiți un e-mail în perioada de garanție și ceri rambursarea banilor, conform condițiilor.'
}];
export const footerLinks = ['Termeni și condiții', 'Politica de confidențialitate', 'Politica de rambursare', 'Contact'];
